import {SxProps, Theme, Typography} from '@mui/material';
import {FC} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import theme from 'src/theme';
import {useSxValue} from './ColoredStatus.hook';
import {ColoredStatusType} from './ColoredStatus.types';
import {pillFitSx, pillShapePhoneSx} from '../pillFit.sx';
import {useFitText} from 'src/hooks/useFitText';

export const ColoredStatus: FC<ColoredStatusType> = ({label, fontSize = 14, component = 'p'}) => {
    const intl = useIntl();
    const fitRef = useFitText<HTMLSpanElement>(`${intl.locale}:${label}`);
    const sxValue: SxProps<Theme> = Object.assign({}, useSxValue(label), {
        padding: theme.spacing(3 / 8, 6 / 8),
        borderRadius: theme.spacing(4 / 8),
        fontWeight: 500,
        fontSize,
        ...pillFitSx,
        // The caller's `fontSize` is a desktop measure - a table cell's. Below a desktop the drawn
        // shape wins, whatever was asked for, so a pill is the same size on every card.
        [theme.breakpoints.down('md')]: pillShapePhoneSx,
    });

    return (
        <Typography ref={fitRef} component={component} sx={sxValue}>
            <FormattedMessage id={label}/>
        </Typography>
    );
};
